import {createActions} from 'reduxsauce';

export const {Types: LocationSearchTypes, Creators: LocationSearchActionCreators} = createActions ({
    locationSearchStart: ['country', 'location'],
    locationSearchSuccess: ['data'],
    locationSearchFailure: ['error']
});